import React, { useCallback } from "react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { NavLink as RouterLink, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import {
  useDisclosure,
  Box,
  Flex,
  IconButton,
  useColorModeValue,
  Avatar,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  keyframes,
  ButtonGroup,
  Button,
  Circle,
  HStack,
  Link as ChakraLink,
  Drawer,
  DrawerBody,
  DrawerContent,
  Stack,
  DrawerCloseButton,
  DrawerOverlay,
  Text,
  Icon,
  Divider,
} from "@chakra-ui/react";
import { useUser } from "../../context/UserContext";
import { FiMessageSquare, FiSearch } from "react-icons/fi";
import { TbLogout2 } from "react-icons/tb";
import { FiUsers, FiBookOpen, FiLayers, FiGrid, FiSettings } from "react-icons/fi";
import { IoGitCompareOutline } from "react-icons/io5";


interface NavLink {
  to: string;
  text: string;
  iconComponent: React.ComponentType;
}

const rotateAnimation = keyframes`
  0% { transform: rotate(0deg); }
  80% { transform: rotate(0deg); }
  100% { transform: rotate(120deg); }
`;
// Define the props interface
interface AvatarWithMemoProps {
  src: string;
  animation: string;
  name: string;
}

// Properly typed memoized Avatar component
const AvatarWithMemo: React.FC<AvatarWithMemoProps> = React.memo(
  ({ src, animation, name }) => {
    return (
      <Avatar
        size="xs"
        src={src}
        animation={animation}
        name={name}
        color="black"
      />
    );
  }
);

// export default AvatarWithMemo;

const WithSubnavigation: React.FC = () => {
  const { username, userId } = useUser();
  const animation = `${rotateAnimation} 3s linear infinite`;
  const drawerDisclosure = useDisclosure();
  const navigate = useNavigate();
  const navLinks: NavLink[] = [
    { to: "/mkg", text: "Metric Graph", iconComponent: IoGitCompareOutline },
    { to: "/plan", text: "Plans", iconComponent: FiLayers },
    { to: "/agent", text: "Agents", iconComponent: FiUsers },
    { to: "/analyze", text: "Insights", iconComponent: FiBookOpen },
    { to: "/library", text: "Library", iconComponent: FiGrid },
    { to: "/chat", text: "Chat", iconComponent: FiMessageSquare },
  ];

  const { logout } = useUser();
  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <Box>
      <Flex
        bg={useColorModeValue("purple.700", "purple.700")}
        color={useColorModeValue("fg.default", "white")}
        py={2}
        px={9}
        borderBottom={1}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.900")}
        align={"center"}
        justify={"space-between"}
        wrap="nowrap"
      >
        <HStack justifyContent="space-between" align="center" ml={7} w="100%">
          <RouterLink to="/">
            <HStack spacing={5}>
              <Circle bg="purple.100" color="fg.default" p={1}>
                <AvatarWithMemo src={logo} animation={animation} name="Anko" />
              </Circle>
              <Text
                fontSize="xl"
                fontWeight="medium"
                color="white"
                fontFamily="Exo 2"
                mb={0}
              >
                Anko
              </Text>
            </HStack>
          </RouterLink>

          <HStack spacing={9} flex={1} justify="center">
            <ButtonGroup
              size="lg"
              variant="text.accent"
              colorScheme="gray"
              spacing={10}
              display={{ base: "none", lg: "flex" }}
            >
              {navLinks.map((link, index) => (
                <ChakraLink
                  as={RouterLink}
                  key={index}
                  to={link.to}
                  position="relative"
                  px={3}
                  py={1}
                  fontSize="lg"
                  color="gray.200"
                  _hover={{ textDecoration: "none", color: "white" }}
                  _after={{
                    content: "''",
                    position: "absolute",
                    width: "0",
                    height: "2px",
                    bottom: "0px",
                    left: "50%",
                    bg: "white",
                    transition: "width 0.3s ease",
                    transform: "translateX(-50%)",
                  }}
                  _activeLink={{
                    // This is for active link styling
                    color: "white", // Custom color for active link
                    fontWeight: "bold",
                    _after: {
                      width: "80%",
                      left: "50%",
                      transform: "translateX(-50%)",
                    },
                  }}
                  sx={{
                    "&:hover::after": {
                      width: "80%",
                      left: "50%",
                      transform: "translateX(-50%)",
                    },
                    "&.active": {
                      "& .nav-icon": {
                        transform: "scale(1.2)", // Makes icon size 5 when active (4 * 1.25 = 5)
                      },
                    },
                  }}
                >
                  <Button>
                    <HStack spacing={2}>
                      <Icon
                        as={link.iconComponent}
                        color="white"
                        boxSize={5}
                        className="nav-icon"
                        transition="transform 0.2s ease"
                      />
                      <Text m={0} fontWeight="600">
                        {link.text}
                      </Text>
                    </HStack>
                  </Button>
                </ChakraLink>
              ))}
            </ButtonGroup>
          </HStack>

          <HStack spacing={3}>
            {/* Username display - hidden on mobile */}
            <Text
              color="white"
              fontWeight="light"
              display={{ base: "none", md: "block" }}
              mb={0}
            >
              {username ? username : "Unknown User"}
            </Text>

            {/* Avatar and user menu */}
            <ButtonGroup variant="tertiary.accent" spacing="1">
              <IconButton
                icon={<FiSearch />}
                aria-label="Search"
                display={{ base: "flex", lg: "none" }}
                isRound
              />
              <Menu>
              <MenuButton>
                <Avatar
                  size="sm"
                  name={username ? username : "Anko"}
                  bg="green.700"
                  borderColor="#fff2f8"
                  borderWidth="1px"
                  color="white"
                  fontWeight="bold"
                />
              </MenuButton>

                <MenuList zIndex={100}>
                {/* <Text
                    mb={2}
                    color="black"
                    fontSize="md"
                    textAlign="left"
                    ml={2}
                    fontWeight={500}
                  >
                   {username ? username : "Unknown User"}
                  </Text> */}
                  {/* <Divider my={1}/>  */}
                  {userId?.toString() === "02c73738-9481-4d0f-85c4-e927c6a09d09" ? (
                    <>
                      <MenuItem
                        onClick={() => navigate("/old-eva")}
                        icon={<Icon as={FiSettings} boxSize={5} color="red.500" />}
                        color="black"
                        fontWeight="semibold"
                      >
                        Eva
                      </MenuItem>
                      <MenuItem
                        onClick={() => navigate("/eva")}
                        icon={<Icon as={FiSettings} boxSize={5} color="red.500" />}
                        color="black"
                        fontWeight="semibold"
                      >
                        New Darwin Eva
                      </MenuItem>
                      <Divider/>
                    </>
                  )
                  : <></>}
                  <MenuItem
                    onClick={handleLogout}
                    icon={<Icon as={TbLogout2} boxSize={5} color="red.500" />}
                    color="black"
                    fontWeight="semibold"
                  >
                    Logout
                  </MenuItem>
                </MenuList>
              </Menu>
            </ButtonGroup>
          </HStack>
        </HStack>

        <IconButton
          aria-label="Open Menu"
          size="md"
          mr={2}
          bg="#4e1e6c"
          color="#4e1e6c"
          icon={
            drawerDisclosure.isOpen ? (
              <CloseIcon />
            ) : (
              <HamburgerIcon color="white" />
            )
          }
          display={{ md: "none" }}
          onClick={drawerDisclosure.onToggle}
        />
      </Flex>

      <Drawer
        isOpen={drawerDisclosure.isOpen}
        placement="top"
        onClose={drawerDisclosure.onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody mt="16">
            <Stack spacing="6" align="stretch">
              {navLinks.map((item, index) => (
                <Button
                  key={index}
                  as={RouterLink}
                  to={item.to}
                  size="lg"
                  variant="text"
                  colorScheme="gray"
                >
                  <HStack spacing={2}>
                    <Icon
                      as={item.iconComponent}
                    />
                    <Text mb={0}>{item.text}</Text>
                  </HStack>
                </Button>
              ))}
              {userId?.toString() === "02c73738-9481-4d0f-85c4-e927c6a09d09" ? (
                <>
                  <Button
                    key="eva"
                    as={RouterLink}
                    to="/old-eva"
                    size="lg"
                    variant="text"
                    colorScheme="gray"
                  >
                    <HStack spacing={2}>
                      <Icon as={FiSettings} />
                      <Text mb={0}>Eva</Text>
                    </HStack>
                  </Button>
                  <Button
                    key="new-darwin-eva"
                    as={RouterLink}
                    to="/eva"
                    size="lg"
                    variant="text"
                    colorScheme="gray"
                  >
                    <HStack spacing={2}>
                      <Icon as={FiSettings} />
                      <Text mb={0}>New Darwin Eva</Text>
                    </HStack>
                  </Button>
                </>
              ): <></>}
              <Button
                onClick={handleLogout}
                bg="#4e1e6c"
                color="white"
                _hover={{ bg: "#4e1e6c", color: "white" }}
              >
                Logout
              </Button>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default WithSubnavigation;